import { Route } from 'react-router'

import AlbumsScene from './albums'
import Compositions from './compositions'
import SceneEvents from './events'
import SceneEventsNew from './events/new'
import Profile from './profile'
import { Authenticated } from 'routes'


export function Account(props) {
  const path = props.match.path
  return (
    <Authenticated>
      <Route exact path={`${path}/compositions/s/:s`} component={Compositions}/>
      <Route exact path={`${path}`} component={Compositions}/>
      <Route exact path={`${path}/albums/s/:s`} component={AlbumsScene}/>
      <Route exact path={`${path}/albums`} component={AlbumsScene}/>
      <Route exact path={`${path}/events`} component={SceneEvents}/>
      <Route exact path={`${path}/events/new`} component={SceneEventsNew}/>
      <Route exact path={`${path}/profile`} component={Profile}/>
    </Authenticated>
  )
}
